import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/home/grass-role.webp'


const _hoisted_1 = { class: "flex flex-col gap-16 mb-20 pt-8 md:mt-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto max-w-[433px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-georgia text-2xl md:text-3xl font-bold text-center text-green" }, " Choose the highest quality turf for your yard! ")
], -1)
const _hoisted_3 = { class: "w-web-panel mx-auto relative max-w-[95%]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "z-0 bg-[url(@/assets/home/garden.webp)] h-[560px] bg-contain flex items-center justify-center w-[440px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-[40px] font-bold text-white max-w-96" }, " What sets ProGreen apart from the Competition? ")
], -1)
const _hoisted_5 = { class: "absolute -bottom-24 right-0 shadow-lg w-[440px] z-10 bg-white px-12 pt-3 pb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mx-auto w-60"
}, null, -1)
const _hoisted_7 = { class: "flex flex-col gap-6" }

import CheckedBullet from "@/components/common/checked-bullet.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'hq-turf',
  setup(__props) {

const bulletPoints = [
  "15 Year Manufacturer's Warranty",
  "100% made in North America",
  "Workmanship Warranty",
  "ProFlow™ Backing",
  "Diamond Shaped Blades",
  "Cool Fiber Technology",
  "Highest Quality Resins From Dow-Dupont",
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bulletPoints, (bullet) => {
            return _createVNode(CheckedBullet, { key: bullet }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(bullet), 1)
              ]),
              _: 2
            }, 1024)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})